import { AgentStudioDataSourceStore } from "./stores/AgentStudioDataSourceStore";
import { AgentStudioStore } from "./stores/AgentStudioStore";
import { AgentStudioDataSourceStoreMockPlugin } from "./stores/mocks/AgentStudioDataSourceStoreMockPlugin";
import { AgentStudioStoreMockPlugin } from "./stores/mocks/AgentStudioStoreMockPlugin";
import { SiteEnvironmentStore } from "./stores/SiteEnvironmentStore";
import { SiteStore } from "./stores/SiteStore";

// Global store instances.
export const agentStudioStore = new AgentStudioStore({ mockPlugin: AgentStudioStoreMockPlugin, mock: false });
export const agentStudioDataSourceStore = new AgentStudioDataSourceStore({ mockPlugin: AgentStudioDataSourceStoreMockPlugin, mock: false });
export const siteStore = new SiteStore();
export const siteEnvironmentStore = new SiteEnvironmentStore();